import { Paper, Stack } from "@mui/material"
import { type PropsWithChildren, useCallback, useMemo, useState } from "react"
import { SidebarContainer } from "../../layout"
import { SideNavCtx } from "./SideNavContext"
import { SideNavTabs } from "./SideNavTabs"

/** A navigation aware sidebar (links are selected based on current route) */
export const SideNav = ({ children }: PropsWithChildren) => {
  const [links, setLinks] = useState<string[]>([])
  const registerLink = useCallback(
    (newLink: string) => setLinks((existingLinks) => [...existingLinks, newLink]),
    [],
  )
  const [linksStatus, setLinksStatus] = useState<Record<string, boolean>>({})
  const setActiveLink = useCallback(
    (activeLink: string, linkStatus: boolean) => {
      setLinksStatus((state) => ({
        ...state,
        [activeLink]: linkStatus,
      }))
    },
    [links],
  )

  const activeLinkIndex = useMemo(() => {
    const [activeLink] =
      Object.entries(linksStatus).find(([_, active]) => active) ?? []
    if (activeLink) {
      return links.indexOf(activeLink)
    }
    return false
  }, [linksStatus])

  return (
    <SidebarContainer>
      <SideNavCtx.Provider value={{ setActiveLink, registerLink }}>
        <Stack>
          <Paper>
            <SideNavTabs
              orientation="vertical"
              textColor="primary"
              value={activeLinkIndex}
              TabIndicatorProps={{
                sx: { display: activeLinkIndex !== false ? "block" : "none" },
              }}
            >
              {children}
            </SideNavTabs>
          </Paper>
        </Stack>
      </SideNavCtx.Provider>
    </SidebarContainer>
  )
}
